import { useQuery } from "@tanstack/react-query";
import { queryKeys } from "@/queryKeys";
import { borrowerService } from "@/services/borrowers";
import { AppStatus, AppStatusChoice } from "@/types/borrower";

interface UseAppStatusTransitionsReturn {
  choices: AppStatusChoice[];
  transitions: Record<string, AppStatus[]>;
  manualPatchBlocked: AppStatus[];
  loading: boolean;
}

export const useAppStatusTransitions = (
  options: { enabled?: boolean } = {}
): UseAppStatusTransitionsReturn => {
  const { enabled = true } = options;
  const { data, isLoading } = useQuery({
    queryKey: queryKeys.appStatusTransitions(),
    queryFn: () => borrowerService.getAppStatusTransitions(),
    staleTime: 5 * 60 * 1000,
    enabled,
  });

  return {
    choices: data?.choices ?? [],
    transitions: (data?.transitions ?? {}) as Record<string, AppStatus[]>,
    manualPatchBlocked: data?.manual_patch_blocked ?? [],
    loading: isLoading,
  };
};
